module.exports = __webpack_public_path__ + "img/1b46f7c64c4350b94c051fd5978ab304.svg";